import { SCALAR_TYPES } from "src/libs/scalars"
import { ALIGN, CARD_FIELD_TYPE } from "../interfaces" 

import __img from "../../assets/img/image.svg"
import __medallion from "../../assets/img/medallion.svg"
import __title from "../../assets/img/title.svg"
import __text from "../../assets/img/html.svg"
import __check_box from "../../assets/img/check_label.svg"
import __divider from "../../assets/img/divider.svg"
import __cropped_divider from "../../assets/img/cropped_divider.svg"
import __personal_links from "../../assets/img/personal_links.svg"
import __buttons from "../../assets/img/buttons.svg"
import __canvas from "../../assets/img/canvas.svg"
import __label from "../../assets/img/label.svg"
import __empty from "../../assets/img/empty.svg"
import __logo from "../../assets/img/logo.svg"
import __order from "../../assets/img/order.svg"
import __inner_links from "../../assets/img/inner-link.svg"
import __outer_links from "../../assets/img/outer-link.svg"
import __person from "../../assets/img/person.svg" 
import __price from "../../assets/img/price.svg"
import __bubble from "../../assets/img/bubble.svg"
import __statistics_line from "../../assets/img/statistics_line.svg"
import __tags from "../../assets/img/tags.svg"
import __time from "../../assets/img/time.svg"
import __icon from "../../assets/img/icon.svg"
import { LANDING_SCALAR } from "../landin_scalars"
import { ANIMATED_STYLE } from "src/libs/interfaces/animated"

const cardFieldsDefault = () : any => {
    const defltFields = {
        height: {
            type: SCALAR_TYPES.SLIDER,
            subtitle: "Height", 
            min: 30,
            max: 330,
            stepSize:1,
            labelStepSize: 100,
            required: false,
            thread: false,
            editable: true,
            default: 30,
            tab: "main",
        }, 
        width: {
            type: SCALAR_TYPES.SLIDER,
            subtitle: "Width", 
            min: 30,
            max: 330,
            stepSize:1,
            labelStepSize: 100,
            required: false,
            thread: false,
            editable: true,
            default: 30,
            noDefault: true,
            tab: "main",
        }, 
    }
    const defFinishDefault = {
        animated: {
            type: SCALAR_TYPES.SELECT,
            values: Object.values(ANIMATED_STYLE),
            subtitle: "Emerging animation type", 
            required: false,
            thread: false,
            editable: true,
            tab: "style",
        }, 
        animated_delay: {
            type: LANDING_SCALAR.ANIMATED_DELAY,
            title: "Animated delay",
            visualization: "landingCompositeDataType",
            required: false,
            thread: false,
            editable: true,
            tab: "style",
        }, 
        className: {
            type: SCALAR_TYPES.STRING,
            subtitle: "CSS classes",
            required: false,
            thread: false,
            editable: true,
            tab: "style",
        },
        style: {
            type: SCALAR_TYPES.CSS_PROPERTIES,
            title: "CSS style", 
            required: false,
            thread: false,
            editable: true,
            tab: "style",
        }, 
        containerStyle:{
            type: SCALAR_TYPES.CSS_PROPERTIES,
            title: "Container's CSS style", 
            required: false,
            thread: false,
            editable: true,
            tab: "style",
        },  
        horizontal_align: {
            type: SCALAR_TYPES.SELECT,
            values: Object.values(ALIGN),
            subtitle: "Horizontal align", 
            isHidden: true,
            required: false,
            thread: false,
            editable: true,
            tab: "style",
        }, 
        vertical_align:{
            type: SCALAR_TYPES.SELECT,
            values: Object.values(ALIGN),
            subtitle: "Vertical align", 
            required: false,
            thread: false,
            editable: true,
            default: ALIGN.MIDDLE,
            tab: "style",
        }, 
    }
    const cardFieldsDefault = {
        [ CARD_FIELD_TYPE.IMAGE ]: {
            icon: __img,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    src: {
                        type: SCALAR_TYPES.MEDIA,
                        subtitle: "Image source", 
                        required: false,
                        thread: false,
                        editable: true,
                        tab: "default",
                    }, // URL
                    src_type: {         
                        type: SCALAR_TYPES.TAGS,
                        subtitle: "Mounting in the layout",
                        commentary: "1. The image fits entirely into the space reserved for it.<br>2. The reserved space is filled with an image.",
                        values: [
                            {
                                _id: "src",
                                title: "Image"
                            },
                            {
                                _id: "div",
                                title: "Cropped filled element"
                            },
                        ],
                        default: "div", 
                        noDefault: true,
                        tab: "main",
                    }, // "div" | "img"
                    original_size:{
                        isHidden: true,
                    }, //  string
                    background_position_x: {
                        type: SCALAR_TYPES.NUMBER,
                        subtitle: "Background horizontal shift", 
                        required: false,
                        thread: false,
                        editable: true,
                        default: 1,
                        tab: "default",
                    }, // number
                    hover_size: {
                        type: SCALAR_TYPES.NUMBER,
                        subtitle: "Hover size", 
                        required: false,
                        thread: false,
                        editable: true,
                        default: 0,
                        noDefault: true,
                        tab: "main",
                    }, // number
                    width_fixed: {
                        isHidden: true,
                    }, // string
                    description_title: {
                        type: SCALAR_TYPES.HTML,
                        subtitle: "Title", 
                        required: false,
                        thread: false,
                        editable: true,
                        tab: "default",
                    }, // HTML
                    description: {
                        type: SCALAR_TYPES.HTML,
                        subtitle: "Description", 
                        required: false,
                        thread: false,
                        editable: true,
                        tab: "default",
                    }, // HTML
                    description_style:{
                        type: SCALAR_TYPES.CSS_PROPERTIES,
                        subtitle: "Description CSS style", 
                        required: false,
                        thread: false,
                        editable: true,
                        noDefault: true,
                        tab: "main",
                    }, //  CSSProperties
                    description_class_name: {
                        type: SCALAR_TYPES.STRING,
                        subtitle: "Description's css class names", 
                        required: false,
                        thread: false,
                        editable: true,
                        noDefault: true,
                        tab: "main",
                    }, // string,
                    is_contrast_muar:{
                        type: SCALAR_TYPES.BOOLEAN,
                        subtitle: "Set contrast muar on bottom", 
                        required: false,
                        thread: false,
                        editable: true,
                        noDefault: true,
                        tab: "main",
                    }, //  boolean
                    exact_value: {
                        type: SCALAR_TYPES.NUMBER,
                        subtitle: "Extract value", 
                        required: false,
                        thread: false,
                        editable: true,
                        default: 1,
                        isHidden: true,
                        tab: "default",
                    }, // number // persents
                    link_url : {
                        type: SCALAR_TYPES.STRING,
                        subtitle: "Link URL", 
                        required: false,
                        thread: false,
                        editable: true,
                        tab: "default",
                    }, // string
                    link_target: {
                        isHidden: true,
                    }, // string
                    ...defFinishDefault, 
                }
            },
            card_field: {
                "id": "image",
                "type": "image",
                "hover_size": 20,
                "style": { 
                    "height": 200 
                },
                src_type: "div",
                className: "landing-default-image"
            },
            value: {
                "id": "2-image",
                "data": __img,
                className: "landing-default-image",
            }
        },
        [ CARD_FIELD_TYPE.MEDALLION ]:  {
            icon: __medallion,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: { 
                    ...defltFields,
                    src: {
                        type: SCALAR_TYPES.MEDIA,
                        subtitle: "Image source", 
                        required: false,
                        thread: false,
                        editable: true,
                        tab: "default",
                    }, 
                    radius: {
                        type: SCALAR_TYPES.NUMBER,
                        subtitle: "Radius", 
                        required: false,
                        thread: false,
                        editable: true,
                        default: 75,
                        noDefault: true,
                        tab: "main",   
                    },
                    borderRadius: {
                        type: SCALAR_TYPES.NUMBER,
                        subtitle: "Border radius", 
                        required: false,
                        thread: false,
                        editable: true,
                        default: 0,
                        noDefault: true,
                        tab: "main",
                    }, 
                    is_contrast_muar:{
                        type: SCALAR_TYPES.BOOLEAN,
                        subtitle: "Set contrast muar on bottom", 
                        required: false,
                        thread: false,
                        editable: true,
                        noDefault: true,
                        tab: "main",
                    }, //  boolean
                    hover_size: {
                        type: SCALAR_TYPES.NUMBER,
                        subtitle: "Hover size", 
                        required: false,
                        thread: false,
                        editable: true,
                        default: 0,
                        noDefault: true,
                        tab: "main",
                    }, // number
                    ...defFinishDefault, 
                }
            },
            card_field: {
                "radius": 100,
                "icon": "https://i.pinimg.com/1200x/8c/6e/f2/8c6ef2716fe3e235e15e3e8c9bef4727.jpg",
                "margin": 10,
                "hover_size": -8,
                "color": "#FFFFFF",
                "id": "medallion",
                className: "landing-default-image"
            },
            value: { 
                "id": "2-medallion",
                "data": __medallion,
                className: "landing-default-image",
            }
        },
        [ CARD_FIELD_TYPE.TITLE ]:  {
            icon: __title,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: { 
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                "id": "title", "type": "title"
            },
            value: { 
                "id": "2-title",
                "data": "Заголовок"
            }
        },
        [ SCALAR_TYPES.HTML]:  {
            icon: __text, 
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    text: {
                        type: SCALAR_TYPES.TEXT,
                        subtitle: "Text", 
                        required: false,
                        thread: false,
                        editable: true,
                        tab: "default",
                    },
                    columns: {
                        type: SCALAR_TYPES.SLIDER,
                        subtitle: "Columns", 
                        min:1,
                        max: 12,
                        stepSize: 1,
                        labelStepSize: 2,
                        required: false,
                        thread: false,
                        editable: true,
                        default: 1,
                        noDefault: true,
                        tab: "main",
                    },
                    gap: {
                        type: SCALAR_TYPES.NUMBER,
                        subtitle: "Golumns gap", 
                        required: [ "columns", 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ],
                        thread: false,
                        editable: true,
                        default: 20,
                        noDefault: true,
                        tab: "main",
                    }, 
                    max_length: {
                        type: SCALAR_TYPES.NUMBER,
                        subtitle: "Cut length",
                        commentary: "Max length of text before cut", 
                        required: false,
                        thread: false,
                        min: 0, 
                        editable: true, 
                        noDefault: true,
                        tab: "main",
                    },
                    ...defFinishDefault, 
                }
            },
            card_field: {
                "id": "html", 
                "type": "html"
            },
            value: { 
                "id": "2-2",
                "data": "Редактируемый текст"
            }
        },
        [ CARD_FIELD_TYPE.CHECK_BOX ]:  {
            icon: __check_box,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: { 
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                "id": "checkbox",
                "type": "checkbox",
                "isHidden": 1,
                "tags": [],
                "style": { "marginBottom": 30 }
            },
            value: { 
                "id": "2-tags",
                "data": [
                    { "checked": 1, "title": "Совершенно бесплатно" },
                    { "checked": 1, "title": "Вечно" },
                    { "checked": 1, "title": "Круглосуточная поддержка" },
                    { "checked": 0, "title": "Бутерброд в подарок" }
                ]
            }
        },
        [ CARD_FIELD_TYPE.CROPPED_DIVIDER ]:  {
            icon: __cropped_divider,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: { 
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                "id": "cropped_divider",
                "type": "cropped_divider",
                "isHidden": 1,
                "divider_type": "wave_outline_reverse",
                "divider_width": "100%",
                "divider_color": "#4a6471",
                "divider_height": 330
            },
            value:  { 
                "id": "2-divider", 
                "data": null 
            }
        },
        [ CARD_FIELD_TYPE.DIVIDER ]:  {
            icon: __divider,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                id: "divider",
            },
            value:  { 
                "id": "2-divider", 
                "data": null 
            }
        },
        [ CARD_FIELD_TYPE.PERSONAL_LINKS ]:  {
            icon: __personal_links,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: { 
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                "id": "personal_link",
                "type": "personal_link",
                "personalLinkType": "outline",
                "style": {}
            },
            value: { 
                "id": "2-sc",
                "data": {
                    "sc": {
                        "dzen": "https://dzen.me/341235677",
                        "vk": "https://vk.com/feed?w=wall-1830250_17103",
                        "telegram": "https://ru.pinterest.com/pin/39688040460739816/",
                        "rutube": "https://rutube.ru/video/69cd337cda701e0f513626f107321c3c/"
                    } 
                }
            }
        }, 
        [ CARD_FIELD_TYPE.ICON ]:  {
            icon: __icon,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                
            },
            value: { 
                "data": "https://i.pinimg.com/736x/16/c0/e5/16c0e5df339e1061deb5535d8f6662f0.jpg"
            }
        },
        [ CARD_FIELD_TYPE.BACKGROUND ]:  {
            icon: __img,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                
            },
            value: { 
                "data": "https://i.pinimg.com/736x/16/c0/e5/16c0e5df339e1061deb5535d8f6662f0.jpg"
            }
        },
        [ CARD_FIELD_TYPE.BUTTONS ]:  {
            icon: __buttons,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                id: "books-1-buttons",
                "type": "buttons",
                "design_type": "round",
                "button_color": "#4f5c70",
                "horizontal_align": "end",
                "vertical_align": "end",
                "style": {
                    "width": 170,
                    "heigth": 26
                },
                "labelStyle": {
                    "fontSize": 17
                }
            },
            value: { 
                "buttons": [ 
                    {
                        "id": "buttons-0",
                        "label": "Подробнее",
                        "url": "https://mytopos.su/npp",
                        "design_type": "round_outline",                                                                     
                        "border_width": 1,
                        "button_color": "#000000",
                        "style": {
                            "width": 200,
                            "height": 24,
                            "textTransform": "uppercase",
                            "fontWeight": 700
                        }
                    },
                    {
                        "id": "buttons-1",
                        "label": "Смотреть",
                        "rightIcon": "fas fa-caret-right",
                        "url": "https://disk.yandex.ru/i/3EfXzJ3JQmIq_w"
                    }
                ],
            }
        },
        [ CARD_FIELD_TYPE.CANVAS ]:  {
            icon: __canvas,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                 
            },
            value: { 
                 
            }
        },
        [ CARD_FIELD_TYPE.CATEGORY_LABEL ]:  {
            icon: __label,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                 
            },
            value: { 
                category: {
                    color: "#7c0505",
                    icon: "fas fa-wrench",
                },
                title: "Основные"
            }
        },
        [ CARD_FIELD_TYPE.EMPTY ]:  {
            icon: __empty,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                "id": "empty",
                "type": CARD_FIELD_TYPE.EMPTY,
                style: {
                    height: 100,
                    BackgroundColor: "#769276"
                }
            },
            value: { 
                  
            }
        },
        [ CARD_FIELD_TYPE.LOGO ]:  {
            icon: __logo,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                "id": "logo",
                "type": CARD_FIELD_TYPE.LOGO,
            },
            value: { 
                "src": "https://prod-eks-static-assets.npr.org/chrome_svg/npr-logo-2025.svg",
                "link_url": "https://npr.org/",
                "width": 130,
                "style": { "padding": 10, "color": "#FFFFFFDD" }
            }
        },
        [ CARD_FIELD_TYPE.ORDER ]:  {
            icon: __order,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                "id": "order",
                "type": CARD_FIELD_TYPE.ORDER,
                is_show_full:true,
                significant_zero: true,
            },
            value: { 
                order: 1, 
            }
        },
        [ CARD_FIELD_TYPE.OUTER_LINK ]:  {
            icon: __outer_links,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                 "id": "outlink",
                "type": CARD_FIELD_TYPE.OUTER_LINK,
            },
            value: { 
                data: {
                    label: "Далее",
                    url: "https://ya.ru",
                }
            }
        },
        [ CARD_FIELD_TYPE.INNER_LINK ]:  {
            icon: __inner_links,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                 "id": "innerlink",
                "type": CARD_FIELD_TYPE.INNER_LINK,
            },
            value: { 
                data: {
                    label: "Далее",
                    url: "https://ya.ru",
                }
            }
        },
        [ CARD_FIELD_TYPE.PERSON ]:  {
            icon: __person,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                 "id": "person",
                "type": CARD_FIELD_TYPE.PERSON,
            },
            value: { 
                "data": {
                  "user": {
                    "id": "11",
                    "display_name": "Потап Потапыч Левиофанъ",
                    "avatar": "https://i.pinimg.com/736x/8f/3d/dc/8f3ddcf4d9ad1327f77dc802ec712b1d.jpg",
                    "description": "Умная каракатица. Завуч"
                  }
                }
            }
        },
        [ CARD_FIELD_TYPE.PRICE ]:  {
            icon: __price,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                 "id": "price",
                "type": CARD_FIELD_TYPE.PRICE,
            },
            value: { 
                data: {

                }
            }
        },
        [ CARD_FIELD_TYPE.SPEECH_BUBBLE ]:  {
            icon: __bubble,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                id: "10-1-speech-bubble", 
                "type": CARD_FIELD_TYPE.SPEECH_BUBBLE,
                "strokeWidth": 2,
                "tailPositionX": 85,
                "style": {
                    "boxShadow": "0 7px 5px 0px #00000012",
                    "marginButtom": -10
                },
                "data": { "type": "html", "className": "py-2 px-3" }
            },
            value: { 
                "data": {
                  "id": "101-card-1-bubble",
                  "data": "<p>Это всё конечно хорошо. Это просто радувает нас, как ёлочка"
                }
            }
        },
        [ CARD_FIELD_TYPE.STATISTIC_LINE ]:  {
            icon: __statistics_line,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                "id": "sl",
                "type": CARD_FIELD_TYPE.STATISTIC_LINE,
                 "items": [
                    { "id": "8-1-1", "title": "Известность" },
                    { "id": "8-1-2", "title": "Порядочность" },
                    { "id": "8-1-3", "title": "Талант" },
                    { "id": "8-1-4", "title": "Чистоплотность" }
                ],
                "min": 0,
                "max": 5,
                "style": {}
            },
            value: { 
                "data": [32, 6, 98, 26]
            }
        },
        [ CARD_FIELD_TYPE.TAGS ]:  {
            icon: __tags,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
                "id": "tags",
                "type": CARD_FIELD_TYPE.TAGS,
                 round: true
            },
            value: { 
                data: [
                    {
                        id: "tags",
                        checked: true,
                        title: "Первый"
                        
                    }
                ] 
            }
        },
        [ CARD_FIELD_TYPE.TIME ]:  {
            icon: __time,
            schema: {
                tabs: [
                    {
                        _id: "main",
                        title: "main",
                    },
                    {
                        _id: "default",
                        title: "Defaults",
                    },
                    {
                        _id: "style",
                        title: "Stylize",
                    },
                ],
                apollo_fields: {
                    ...defltFields,
                    
                    ...defFinishDefault, 
                }
            },
            card_field: {
               "id": "time",
                "type": CARD_FIELD_TYPE.TIME,
                height: 75,  
                style: {
                    padding: "10px 20px",
                }
            },
            value: {
                "start_time": new Date().getTime() / 1000,
                "finish_time": new Date(new Date().getTime() + 24 * 60 * 60 * 1000).getTime() / 1000,
                // "intent": "success"
            }
        }, 
    }
    return cardFieldsDefault
}

export default cardFieldsDefault